import { render, staticRenderFns } from "./ResponsivePlans.vue?vue&type=template&id=67c04690&"
import script from "./ResponsivePlans.vue?vue&type=script&lang=js&"
export * from "./ResponsivePlans.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResponsivePlans.vue"
export default component.exports